var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nopermission"},[_c('div',{staticClass:"tips"},[_c('p',[_vm._v("分享链接不存在或没有访问权限")])])])}]

export { render, staticRenderFns }